import { ImageManagementSection } from '@/components/shared/ImageManagementSection';
import { useChargeImages } from '../hooks/useChargeImages';
import { useUploadChargeImages } from '../hooks/useUploadChargeImages';

export interface ChargeImagesSectionProps {
  jobId: number;
  chargeId: number;
  canDelete?: boolean;
}

/**
 * Charge-specific image management section
 * Thin wrapper around ImageManagementSection with charge-specific hooks
 * Used for signed contracts, change orders, and other charge documents
 */
export function ChargeImagesSection({
  jobId,
  chargeId,
  canDelete = false,
}: ChargeImagesSectionProps) {
  const { images, isLoading, error: fetchError, refetch, deleteImage } = useChargeImages(jobId, chargeId);
  const { uploadImages, isUploading, error: uploadError } = useUploadChargeImages(jobId, chargeId, refetch);

  return (
    <ImageManagementSection
      images={images}
      isLoading={isLoading}
      fetchError={fetchError}
      uploadError={uploadError}
      isUploading={isUploading}
      onUpload={uploadImages}
      onDelete={deleteImage}
      canDelete={canDelete}
      uploadLabel="Upload Documents"
      galleryLabel="Uploaded Documents"
    />
  );
}
